import {Avatar, Button, Col, Descriptions, message, Row, Tabs, Input, Dropdown, Menu, Icon, Modal, Alert} from 'antd';
import PersonDelete from 'common/person/delete';
import { CountryCodeSelect } from 'components/form/select/CountryCodeSelect';
import EmployerSelectWithData from 'components/form/select/EmployerSelect';
import CovidVaccineDates from 'components/PassengerEditor/CovidVaccineDates';
import { withUserGroups } from 'components/userGroup';
import QueryResultContext from 'context/query-result-context';
import gql from 'graphql-tag';
import compose from 'lodash.flowright';
import PropTypes from 'prop-types';
import React, { Component, useState } from 'react';
import {Mutation, useQuery, withApollo} from 'react-apollo';
import WithOrgData from '../../components/WithOrgData';
import { CredentialManagerWithData } from '../CredentialManager';
import './PassengerEditor.less';
import FlightCheckinDetails from "./flight-check-in-details";
import {withRouter} from "react-router-dom";
import {PassengerQuery} from "./graphql";
import LoadingContent from "../LoadingContent";
import useDeletePax from "./actions/delete-pax";
import {hasEditPermission} from "./util";
import {canDeletePerson} from "common/person/delete/operation";
import {OrganizationSelect} from "../form/select/OrganizationSelect";


const SET_PERSON = gql`

    mutation SetPerson(
        $payload: PersonInput!,
        $orgID: ID!
    ){
        setPerson(
            payload: $payload
            orgID: $orgID
        ){
            _id
            dob
            nation
            notes
            employerID {
                _id
                name
            }
            contactInfo {
                phone {
                    number
                    type
                }
            }
        }
    }
`

class PassengerEditor_Internal extends Component {
    state = {
        error: false,
        checkinDetailsFormState: null,
        deleteConfirmState: {
            visible: false,
            isDeleting: false
        },
        isSaving: false
    }

    hasEditPermission = () => (
        hasEditPermission(this.props.location.pathname, this.props.userGroups)
    )

    passengerWasUpdated = () => {
        if (typeof this.props.onPassengerUpdated === 'function'){
            this.props.onPassengerUpdated();
        }
    }

    setPicError = (error) => {
        this.setState({ error: error })
    }

    renderPicture = () => {
        const { data } = this.props;
        if (!data.personID) return null;
        const personId = data.personID._id;
        const path = "https://s3.amazonaws.com/df-web-img/pax/" + personId + "/" + personId + "_prof.jpeg";
        if (this.state.error) {
            return (
                <Avatar shape="square" size={300} style={{ marginBottom: 20 }}>No Image Found</Avatar>
            )
        }
        else {
            return (
                <Avatar shape="square" size={300} style={{ marginBottom: 20 }} src={path} onError={e => this.setPicError(true)} />
            )
        }
    }



    renderNationSelect = () => {
        const { data, edit } = this.props;
        if (!data.personID) return null;

        return (
            <Mutation
                mutation={SET_PERSON}
                onCompleted={() => message.success('Passenger nation successfuly updated')}
                onError={() => message.error('Failed to update passenger\'s nation. An error has occurred.')}
            >
                {(mutate) => {
                    return (
                        <CountryCodeSelect
                            disabled={!edit || !this.hasEditPermission()}
                            value={data.personID.nation}
                            onChange={(nation) => {
                                mutate({
                                    variables: {
                                        payload: {
                                            _id: this.props.data.personID._id,
                                            nation
                                        },
                                        orgID: this.props.orgData.getOrgByType('transporter')._id
                                    },
                                    optimisticResponse: {
                                        __typename: 'Mutation',
                                        setPerson: {
                                            __typename: 'Person',
                                            ...this.props.data.personID,
                                            nation
                                        }
                                    }
                                })
                            }}
                        >
                        </CountryCodeSelect>
                    )
                }}
            </Mutation>
        )
    }

    renderInfo = () => {
        const { data, edit } = this.props;
        if (!data.personID) return null;
        return (
            <Tabs.TabPane key="personalInfo" tab="Personal Information">
                <Row type="flex" gutter={12} style={{ flexWrap: 'nowrap' }}>
                    <Col>
                        {this.renderPicture()}
                    </Col>
                    <Col style={{ flex: 1 }}>
                        <Descriptions column={1} bordered size="small" title="Personal Info">
                            <Descriptions.Item label="Date of Birth"><span className="pepi-value">{data.personID.dob}</span></Descriptions.Item>
                            <Descriptions.Item label="Phone Number">
                                <span className="pepi-value">{data.personID?.contactInfo?.phone?.number ? (
                                    `${data.personID.contactInfo.phone.number} (${data.personID.contactInfo.phone.type})`
                                ) : null}</span>
                            </Descriptions.Item>
                            <Descriptions.Item label="Nation">{this.renderNationSelect()}</Descriptions.Item>
                            <Descriptions.Item label="Employer">
                                <QueryResultContext.Consumer>
                                    {(queryResult) => (
                                        <Mutation
                                            mutation={gql`
                                        mutation SetPersonPaxEmployer(
                                            $personPayload: PersonInput!,
                                            $paxPayload: PaxNodeInput!,
                                            $orgID: ID!
                                        ){
                                            setPerson(
                                                payload: $personPayload
                                                orgID: $orgID
                                            ){
                                                _id
                                                employerID {
                                                    _id
                                                    name
                                                }
                                            }
                                            setPaxNode(
                                                payload: $paxPayload
                                            ){
                                                _id
                                                employerID{
                                                    _id
                                                    name
                                                }
                                                personID {
                                                    _id
                                                    employerID{
                                                        _id
                                                        name
                                                    }
                                                }
                                            }
                                        }
                                        `}
                                            onCompleted={() => {
                                                message.success('Passenger employer successfuly updated')
                                                console.log('queryResult', queryResult);
                                                if (queryResult) {
                                                    queryResult.refetch();
                                                }
                                            }}
                                            onError={() => message.error('Failed to update passenger\'s employer. An error has occurred.')}
                                        >
                                            {(mutate) => {

                                                return (
                                                    <EmployerSelectWithData
                                                        mode="single"
                                                        disabled={!edit || !this.hasEditPermission() || this.state.isSaving}
                                                        showSearch
                                                        labelInValue
                                                        style={{ width: 200 }}
                                                        value={{ key: data.employerID._id, label: data.employerID.name }}
                                                        onChange={(e) => {
                                                            this.setState({ isSaving: true });
                                                            const hideMsg = message.loading("Updating passenger employer...", 0);
                                                            let empObj = {
                                                                _id: e.key,
                                                                name: e.label,
                                                                __typename: 'Employer'
                                                            }
                                                            mutate({
                                                                variables: {
                                                                    personPayload: {
                                                                        _id: this.props.data.personID._id,
                                                                        employerID: e.key
                                                                    },
                                                                    paxPayload: {
                                                                        _id: this.props.data._id,
                                                                        employerID: e.key,
                                                                        tpID: this.props.orgData.getOrgByType('transporter')._id
                                                                    },
                                                                    orgID: this.props.orgData.getOrgByType('transporter')._id
                                                                },
                                                                update: (cache, { data: { setPaxNode } }) => {
                                                                    cache.writeFragment({
                                                                        fragment: gql`
                                                                    fragment Pax on PaxNode {
                                                                        _id
                                                                        employerID {
                                                                            _id
                                                                            name
                                                                        }
                                                                    }
                                                                `,
                                                                        id: 'PaxNode:' + setPaxNode._id,
                                                                        data: {
                                                                            ...setPaxNode,
                                                                            __typename: 'PaxNode',
                                                                            employerID: empObj
                                                                        }
                                                                    })
                                                                },
                                                                optimisticResponse: {
                                                                    __typename: 'Mutation',
                                                                    setPerson: {
                                                                        __typename: 'Person',
                                                                        ...this.props.data.personID,
                                                                        employerID: empObj
                                                                    },
                                                                    setPaxNode: {
                                                                        __typename: 'PaxNode',
                                                                        ...this.props.data,
                                                                        personID: {
                                                                            ...this.props.data.personID,
                                                                            employerID: empObj
                                                                        },
                                                                        employerID: empObj
                                                                    }
                                                                }
                                                            })
                                                                .then(() => {
                                                                    hideMsg();
                                                                    this.setState({ isSaving: false });
                                                                })
                                                                .catch((err) => {
                                                                    hideMsg();
                                                                    this.setState({ isSaving: false });
                                                                })
                                                        }}
                                                        placeholder="Select an Employer"
                                                    >
                                                    </EmployerSelectWithData>
                                                )
                                            }}
                                        </Mutation>
                                    )}
                                </QueryResultContext.Consumer>
                            </Descriptions.Item>
                            <Descriptions.Item label="Contractor">
                                <QueryResultContext.Consumer>
                                    {(queryResult) => (
                                        <Mutation
                                            mutation={gql`
                                        mutation SetPaxContractor(
                                            $paxPayload: PaxNodeInput!
                                        ){
                                            setPaxNode(
                                                payload: $paxPayload,
                                                includeNulls: true
                                            ){
                                                _id
                                                contractorID
                                                contractorDoc{
                                                    _id
                                                    name
                                                }
                                            }
                                        }
                                        `}
                                            onCompleted={() => {
                                                message.success('Passenger contractor successfuly updated')
                                                if (queryResult) {
                                                    queryResult.refetch();
                                                }
                                            }}
                                            onError={() => message.error('Failed to update passenger\'s contractor. An error has occurred.')}
                                        >
                                            {(mutate) => {
                                                return (
                                                    <OrganizationSelect
                                                        classTypes={['flytsuite.employer']}
                                                        labelInValue={true}
                                                        value={{ key: data.contractorDoc?._id, label: data.contractorDoc?.name }}
                                                        disabled={!edit || !this.hasEditPermission() || this.state.isSaving}
                                                        style={{ width: 200 }}
                                                        placeholder="Select a Contractor"
                                                        onChange={(e) => {
                                                            let conObj = e ? {
                                                                _id: e.key,
                                                                name: e.label,
                                                                __typename: 'Employer'
                                                            } : null

                                                            const hideMsg = message.loading("Updating passenger contractor...", 0);
                                                            this.setState({ isSaving: true });

                                                            mutate({
                                                                variables: {
                                                                    paxPayload: {
                                                                        _id: this.props.data._id,
                                                                        contractorID: e?.key || null,
                                                                        tpID: this.props.orgData.getOrgByType('transporter')._id
                                                                    }
                                                                }
                                                            })
                                                                .then(() => {
                                                                    hideMsg();
                                                                    this.setState({ isSaving: false });
                                                                })
                                                                .catch((err) => {
                                                                    hideMsg();
                                                                    this.setState({ isSaving: false });
                                                                })
                                                        }}
                                                    />
                                                )
                                            }}
                                        </Mutation>
                                    )}
                                </QueryResultContext.Consumer>
                            </Descriptions.Item>
                        </Descriptions>
                    </Col>
                </Row>
            </Tabs.TabPane>
        )
    }

    renderCredentials = () => {
        const { data } = this.props;
        if (!data.personID) return null;

        return (
            <Tabs.TabPane key="cred" tab="Credentials">
                <CredentialManagerWithData showCount personId={
                    data && data.personID && data.personID._id
                } paxID={data && data._id} />
            </Tabs.TabPane>
        )
    }

    renderCheckinDetails = () => {

        if (String(this.props.location.pathname).startsWith('/app/boats')){
            // Tab will not be available in boats/docks part of website.
            return null;
        }

        return (
            <Tabs.TabPane key="checkin-details" tab="Check-in Details">
                <FlightCheckinDetails
                    editingEnabled={this.props.edit}
                    initialData={this.props.data}
                    formData={this.state.checkinDetailsFormState}
                    onFormDataChanged={(fields) => this.setState({ checkinDetailsFormState: fields })}
                    onPassengerUpdated={this.passengerWasUpdated}
                />
            </Tabs.TabPane>
        )
    }

    handleDeletePassenger = async () => {
        this.setState({ deleteConfirmState: { visible: true, isDeleting: true } });
        try {
            await this.props.deletePax();
        }
        finally {
            this.setState({ deleteConfirmState: { visible: false, isDeleting: false } });
        }
    }

    setDeleteConfirmModal = (state) => () => {
        switch (state){
            case 'open':
                this.setState({ deleteConfirmState: {...this.state.deleteConfirmState, visible: true } });
                break;
            case 'close':
                this.setState({ deleteConfirmState: { ...this.state.deleteConfirmState, visible: false} });
                break;
        }
    }

    renderDeletePaxMenuItem = (menuItems) => {
        if (!this.props.edit) return;

        if (this.props.location.pathname.startsWith('/app/scheduling')){
            // Disable delete button on scheduling
            return;
        }

        menuItems.push(
            <Menu.Item
                key="delete-pax"
                onClick={this.setDeleteConfirmModal('open')}
                disabled={!this.props.deletePaxAllowed}
                title={!this.props.deletePaxAllowed ? 'You are not authorized to perform this function' : ''}
            >
                Delete passenger
            </Menu.Item>
        )
    }

    renderMoreButton = () => {

        const menuItems = [];

        this.renderDeletePaxMenuItem(menuItems);

        const { data } = this.props;
        const personID = data.personID?._id;

        if (personID && data.checkInType !== 'SCHEDULED' && canDeletePerson(this.props.userGroups)) {
            menuItems.push(
                <PersonDelete
                    key={personID}
                    personID={personID}
                    name={`${data.lastName}, ${data.firstName}`}
                    disabled={this.state.isSaving || this.state.deleteConfirmState.visible}
                    onDeleted={this.props.onPersonDeleted}
                />
            );
        }
        if (!menuItems.length) return null;

        return (
            <Dropdown overlay={<Menu>{menuItems}</Menu>} placement="bottomRight">
                <Button aria-label="Passenger actions">Actions <Icon type="down" /></Button>
            </Dropdown>
        );
    }

    render() {
        const { data, style, className, userGroups } = this.props;

        const personDeleted = !data?.personID;
        const moreButton = this.renderMoreButton();

        return (
            <div style={style} className={className}>
                {data && (
                    <h3>{`${data.lastName}, ${data.firstName}`}</h3>
                )}
                {personDeleted && (
                    <Alert
                        type="error"
                        showIcon
                        message="Person record deleted"
                        description="This passenger's associated person record has been deleted. Most information and editing capabilities are unavailable."
                        style={{ marginBottom: 12 }}
                    />
                )}
                <Tabs type="card" defaultActiveKey="personalInfo" tabBarExtraContent={moreButton}>
                    {!personDeleted && this.renderInfo()}
                    {!personDeleted && this.renderCheckinDetails()}
                    {!personDeleted && this.renderCredentials()}
                    {!personDeleted && userGroups.includes('flytsuite.covid19vaxrecords.read') ? (
                        <Tabs.TabPane key="health" tab="Health Info">
                            <CovidVaccineDates personID={data.personID._id} personName={`${data.personID.lastName}, ${data.personID.firstName}`} />
                        </Tabs.TabPane>
                    ) : null}
                    {!personDeleted && this.renderPersonalNotes()}
                </Tabs>

                {/* Delete confirmation modal */}
                <Modal
                    children={<h3>Are you sure? This cannot be undone!</h3>}
                    visible={this.state.deleteConfirmState.visible}
                    onCancel={this.setDeleteConfirmModal('close')}
                    closable={!this.state.deleteConfirmState.isDeleting}
                    footer={
                        [
                            <Button
                                onClick={this.setDeleteConfirmModal('close')}
                                disabled={this.state.deleteConfirmState.isDeleting}
                            >Cancel</Button>,
                            <Button
                                type="danger"
                                onClick={this.handleDeletePassenger}
                                loading={this.state.deleteConfirmState.isDeleting}
                            >Delete PAX</Button>
                        ]
                    }
                />
            </div>
        );
    }

    handleNotesChange = (event) => {
        this.setState({ changedNotes: event.target.value });
    }

    resetNotes = () => {
        this.setState({ changedNotes: undefined });
    }


    renderPersonalNotes = () => {
        const { data, edit } = this.props;
        if (!data.personID) return null;

        /*If there are NO NOTES , then PULL (CURRENT PERSON) NOTES FROM PERSON RECORD*/
        let textAreaValue = this.state.changedNotes || data.personID.notes;

        return (
            <Tabs.TabPane key="notesKey" tab="Notes">
                <Mutation
                    mutation={SET_PERSON}
                    onCompleted={() => {
                        message.success('Passenger notes successfuly updated');
                        this.setState({ changedNotes: undefined });
                    }}
                    onError={() => message.error('Failed to update passenger\'s notes. An error has occurred.')}
                >
                    {(mutate, { loading }) => {
                        return (
                            <>
                                <label>Notes : </label>

                                <Input.TextArea
                                    style={{
                                        resize: 'none'
                                    }}
                                    name="message"
                                    placeholder="Type notes here…"
                                    value={textAreaValue}
                                    onChange={this.handleNotesChange}
                                    rows={15}
                                    cols={50}
                                />

                                <Row style={{ marginTop: 6 }} gutter={6} type="flex">
                                    <Col>
                                        <Button
                                            disabled={!this.state.changedNotes}
                                            onClick={this.resetNotes}
                                        >Reset edits</Button>
                                    </Col>
                                    <Col>
                                        <Button
                                            type="primary"

                                            disabled={!this.state.changedNotes}
                                            loading={loading}

                                            onClick={() => {
                                                mutate({
                                                    variables: {
                                                        payload: {
                                                            _id: this.props.data.personID._id,
                                                            notes: this.state.changedNotes
                                                        },
                                                        orgID: this.props.orgData.getOrgByType('transporter')._id
                                                    },
                                                    optimisticResponse: {
                                                        __typename: 'Mutation',
                                                        setPerson: {
                                                            __typename: 'Person',
                                                            ...this.props.data.personID,
                                                            notes: this.state.changedNotes
                                                        }
                                                    }
                                                })
                                            }}>Save post
                                        </Button>
                                    </Col>
                                </Row>
                            </>
                        )
                    }}
                </Mutation>
            </Tabs.TabPane>
        )
    }
}

PassengerEditor_Internal.propTypes = {
    data: PropTypes.object.isRequired,
    onSave: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    editing: PropTypes.string,
    onRemove: PropTypes.func,
    onPassengerUpdated: PropTypes.func,
    onPassengerDeleted: PropTypes.func,
    deletePax: PropTypes.func,
    onPersonDeleted: PropTypes.func
}

function PassengerEditor(props){

    const { data: dataProp, edit, onCancel, loadingStyle, ...restProps } = props;

    // If parent supplies data property, disregard data and just extract the ID. Use it for the query.
    // Context: Previously, parent components could supply their own pax data, which had a flaw where they could
    // contain varying field selections. This could cause cache misses in apollo client which will disrupt
    // responsiveness of the UI.
    let paxId = dataProp?._id || props.paxId;

    const { data, loading, error, refetch } = useQuery(PassengerQuery, {
        variables: {
            paxId: paxId
        },
        fetchPolicy: 'cache-and-network',
        errorPolicy: 'all',
        pollInterval: 10_000
    });
    
    const paxNode = data?.getPassenger;
    
    const deletePax = useDeletePax(paxNode);
    
    if (!paxNode && loading){
        return <LoadingContent style={loadingStyle} />
    }
    
    let errorAlert = null;
    
    if (error){
        errorAlert = <Alert style={{ marginBottom: 12 }} showIcon type="error" message="Failed to load passenger" />
    }
    
    let paxEditor = null;
    
    if (paxNode){
        paxEditor = (
            <PassengerEditor_Internal
                {...restProps} 
                edit={edit}
                data={paxNode} 
                onCancel={onCancel}
                onPersonDeleted={async () => {
                    const refreshed = await refetch();
                    if (!refreshed.data?.getPassenger || refreshed.data.getPassenger.deletedTs) {
                        await props.onPassengerDeleted?.();
                        onCancel?.();
                    } else {
                        await props.onPassengerUpdated?.();
                    }
                }}
                deletePaxAllowed={deletePax.deletionAllowed}
                deletePax={async () => {
                    try {
                        await deletePax.delete();
                        if (typeof props.onPassengerDeleted === 'function') {
                            props.onPassengerDeleted();
                        }
                        if (typeof props.onCancel === 'function'){
                            // Some parent components use PassengerEditor directly (without PassengerEditorModal)
                            // They listen to onCancel to close a parent modal, so call this too.
                            props.onCancel();
                        }
                        message.success('Deleted passenger successfully');
                    } catch (err) {
                        console.error(err);
                        message.error('Failed to delete passenger. Check console for details.');
                    }
                }}
            />
        )
    }
    
    return <>
        {errorAlert}
        {paxEditor}
    </>
}

PassengerEditor.propTypes = {
    ...PassengerEditor_Internal.propTypes
}


export default compose(
    withApollo,
    WithOrgData,
    withUserGroups,
    withRouter
)(PassengerEditor)